(function () {

    'use strict';

    /**
     * Render a control for Navigation (prev/next) between categories
     */
    var CategoryNavCmp = {
        bindings: {
            category:'<',
            reload: '&'
        },
        controller: CategoryNavCmpCtrl,
        templateUrl: 'category-nav.component.html'
    };

    angular.module('itxApp.catalog').component('categoryNav', CategoryNavCmp);

    CategoryNavCmpCtrl.$inject = [
        'categoryTreeSvc'
    ];

    function CategoryNavCmpCtrl(
        categoryTreeSvc
    ) {
        var _this = this;
        
        _this.showCmp = false;

        _this.$onInit = function () {
            getNavigationCategories();
        };
        
        _this.$onChanges = function(){
            getNavigationCategories();
        };

        _this.goToNext = function () {
            _this.reload({category: _this.next});
        };

        _this.goToPrev = function () {
            _this.reload({category: _this.prev});
        };

        function getNavigationCategories() {
            categoryTreeSvc.getRelatedCategory( _this.category )
                .then(function (obj) {
                    if(obj.next){
                        _this.next = obj.next;
                    } else {
                        _this.next = false;
                    }

                    if(obj.prev){
                        _this.prev = obj.prev;
                    } else {
                        _this.prev = false;
                    }
                    
                    _this.showCmp = true;

                });
        }

    }

})();
